import { createContext } from 'react'
import { ToastProvider } from './useToastProvider'

export default createContext({
  open: (props: ToastProvider) => null,
})
